export const AVAILABLE_LIMITS = [10, 20, 50, 100];
export const DEFAULT_NB_DISPLAYED_PAGES = 5;
